import { SET_TEST_STATUS } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case SET_TEST_STATUS:
            return {
                ...state,
                testStatus: action.payload ? action.payload : [],
            }
        default:
            return state
    }
}
